import { customElement, property } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
import './d-action.js';

/**
 *
 * @fires value-changed - Dispatched immediately after changes by the user
 * @fires value-toggled-on - Dispatched immediately after changes by the user
 * @fires value-toggled-off - Dispatched immediately after changes by the user
 *
 *
 * STATUS OK
 */
@customElement('d-action-toggle')
export class DActionToggle extends LitElement {
  static readonly styles = css`
    :host {
      display: inline-block;
      color: var(--themeColor);
      mix-blend-mode: multiply;
    }

    :host([outskirts]) {
      color: white;
      mix-blend-mode: normal;
    }
  `;

  @property({ type: String })
  onLabel = '';
  @property({ type: String })
  offLabel = '';

  @property({ type: Boolean })
  value = false;

  @property({ type: Boolean, attribute: true })
  outskirts = false;

  private onActionClick(e: MouseEvent) {
    e.stopPropagation();
    this.value = !this.value;
    this.dispatchEvent(
      new CustomEvent('value-changed', {
        bubbles: true,
        composed: true,
        detail: { value: this.value },
      }),
    );
    this.dispatchEvent(
      new CustomEvent(this.value ? 'value-toggled-on' : 'value-toggled-off', {
        bubbles: true,
        composed: true,
        detail: { value: this.value },
      }),
    );
  }

  render() {
    return html`<d-action @click=${this.onActionClick}>${this.value ? this.onLabel : this.offLabel}</d-action>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-action-toggle': DActionToggle;
  }
}
